import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import stl from "./AuthScreen.module.css";
import useIsMobile from "@hooks/useIsMobile";
import OtpVerification from "@/_MiniApps/auth/ui/OTP/OtpVerification";
import AuthFormV2 from "@/_MiniApps/auth/ui/AuthFormV2/AuthFormV2";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useValidate from "@hooks/useValidate";
import { ValidationException } from "@/common/exceptions/ValidationException";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var AuthStep = /*#__PURE__*/function (AuthStep) {
  AuthStep[AuthStep["PhoneNumberInput"] = 0] = "PhoneNumberInput";
  AuthStep[AuthStep["OtpVerification"] = 1] = "OtpVerification";
  return AuthStep;
}(AuthStep || {});
var AuthScreen = function AuthScreen(_ref) {
  var external_links = _ref.external_links,
    design = _ref.design,
    _ref$isSmallPopup = _ref.isSmallPopup,
    isSmallPopup = _ref$isSmallPopup === void 0 ? true : _ref$isSmallPopup,
    onSuccess = _ref.onSuccess,
    _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? undefined : _ref$customClass;
  var isMobile = useIsMobile();
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var refDesign = searchParams.get("ref") || undefined;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useState = useState(AuthStep.PhoneNumberInput),
    currentStep = _useState[0],
    setCurrentStep = _useState[1]; // State to track current step
  var _useSession = useSession(),
    remote_loginOrSignup = _useSession.remote_loginOrSignup,
    isLoading = _useSession.isLoading,
    hasAccount = _useSession.hasAccount;
  var _useValidate = useValidate(),
    validatePhoneNumber = _useValidate.validatePhoneNumber,
    validateName = _useValidate.validateName;
  var _useState2 = useState(""),
    generalError = _useState2[0],
    setGeneralError = _useState2[1];
  var _useState3 = useState(new ValidationException()),
    validationError = _useState3[0],
    setValidateError = _useState3[1];
  var _useState4 = useState({
      full_name: "",
      phone_number: ""
    }),
    fields = _useState4[0],
    setFields = _useState4[1];
  var resetValidationError = function resetValidationError() {
    setValidateError(new ValidationException());
  };
  var _useState5 = useState(design),
    localDesign = _useState5[0],
    setLocalDesign = _useState5[1];
  useEffect(function () {
    if (refDesign === "aribForm") {
      // Update local state instead of modifying the prop directly.
      setLocalDesign(function (prevDesign) {
        return _objectSpread(_objectSpread({}, prevDesign), {}, {
          description: t("apply_financing_log_create_account")
        });
      });
    }
  }, []); // include refDesign and t in dependencies

  var bannerImage = isMobile ? localDesign.banners.mobile : localDesign.banners.desktop;

  // Handle phone number submission
  var handlePhoneNumberSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var exp, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            resetValidationError();
            e.preventDefault();
            _context.p = 1;
            tryToClientValidateAndThrowValidationException();
            _context.n = 2;
            return remote_loginOrSignup(fields.phone_number);
          case 2:
            // Call remote_loginOrSignup function from context
            setCurrentStep(AuthStep.OtpVerification); // Move to OTP verification step
            _context.n = 6;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            if (!(_t instanceof ValidationException)) {
              _context.n = 5;
              break;
            }
            exp = _t;
            if (!exp.isError("phone_number")) {
              _context.n = 4;
              break;
            }
            return _context.a(2, setValidateError(exp));
          case 4:
            if (!exp.isError("full_name")) {
              _context.n = 5;
              break;
            }
            return _context.a(2, setValidateError(exp));
          case 5:
            setGeneralError(_t.message);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handlePhoneNumberSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleFieldsChange = function handleFieldsChange(name) {
    return function (e) {
      resetValidationError();
      var value = e.target.value;
      if (name === "phone_number" && value.length > 10) return;
      setFields(function (prevVal) {
        return _objectSpread(_objectSpread({}, prevVal), {}, _defineProperty({}, name, value));
      });
    };
  };
  var tryToClientValidateAndThrowValidationException = function tryToClientValidateAndThrowValidationException() {
    var errors = {};
    if (validatePhoneNumber(fields.phone_number)) {
      throw new ValidationException([{
        name: "phone_number",
        message: validatePhoneNumber(fields.phone_number)
      }]);
    }
    if (fields.full_name && validateName(fields.full_name)) {
      throw new ValidationException([{
        name: "full_name",
        message: validateName(fields.full_name)
      }]);
    }
    return errors;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.wrapper, isSmallPopup ? stl.isSmallPopup : undefined, customClass].join(" ")
  }, refDesign === "aribForm" && currentStep !== AuthStep.OtpVerification && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.imgWrapper
  }, /*#__PURE__*/React.createElement("picture", {
    className: "w-[85%]"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 1025px)",
    srcSet: CDN_LINK + "/assets/images/aribeloginMobile.svg"
  }), /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 1024px)",
    srcSet: CDN_LINK + "/assets/images/aribeloginMobile.svg"
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/aribeloginMobile.svg",
    alt: "banner"
  })))), refDesign !== "aribForm" && currentStep !== AuthStep.OtpVerification && /*#__PURE__*/React.createElement("div", {
    className: stl.imgWrapper
  }, bannerImage && /*#__PURE__*/React.createElement("img", {
    alt: "banner",
    src: bannerImage
  }), !bannerImage && /*#__PURE__*/React.createElement("div", {
    className: stl.imgPlaceholder
  })), currentStep === AuthStep.OtpVerification && /*#__PURE__*/React.createElement(OtpVerification, {
    source: "signup",
    after_verify_callback: onSuccess,
    scenario: hasAccount ? "login" : "signup",
    phone_number: fields.phone_number,
    onEditNumber: function onEditNumber() {
      return setCurrentStep(AuthStep.PhoneNumberInput);
    },
    design: {
      btnText: tShort("phone_number_verification", {
        "ns": "otp_screen"
      }),
      label: tShort("enter_code_sent_to", {
        "ns": "otp_screen"
      }),
      className: "VerifyOtp"
    }
  }), currentStep === AuthStep.PhoneNumberInput && /*#__PURE__*/React.createElement(AuthFormV2, {
    external_links: external_links,
    handleFieldsChange: handleFieldsChange,
    fields: fields,
    validationError: validationError,
    loading: isLoading,
    onSubmit: handlePhoneNumberSubmit,
    generalError: generalError,
    authScreenDesign: localDesign
  }));
};
export default AuthScreen;